import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth/auth.service';
import { StorageKey } from '../constants/storage.constant';

// Locale is resolved server-side from the authenticated user's stored
// preference, never from a request header (api 4.md: "Accept-Language is not
// read anywhere" — true of any language header, not just that one), so none
// is sent here.
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token =
    inject(AuthService).userData()?.auth?.token ??
    localStorage.getItem(StorageKey.OTP_TOKEN);

  req = req.clone({
    headers: req.headers
      .set('X-Authorization', environment.auth_key)
      .set('Authorization', `Bearer ${token}`),
  });

  return next(req);
};
